import React, { useEffect, useRef, useState } from 'react';
// import mujaImage from '../../assets/muja.jpeg'; // Removed unused import
import  semantic1 from '../../assets/semantic1.jpeg';
import semantic2 from '../../assets/semantic2.jpeg';
import semantic3 from '../../assets/semantic3.jpeg';
import semantic4 from '../../assets/semantic4.jpeg';
import semantic5 from '../../assets/semantic5.jpeg';
import './SemanticSearchEngine.css';

const SemanticSearchEngine = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [typedText, setTypedText] = useState('');
  const [showPersona, setShowPersona] = useState(false);
  const [showCoachingCard, setShowCoachingCard] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % 5);
    }, 4000);

    return () => clearInterval(slideInterval);
  }, []);

  const fullText = "Implement a powerful semantic search engine using advanced natural language processing and vector embeddings to understand user queries and retrieve the most relevant information from large datasets. By leveraging transformer-based models and similarity algorithms, this project enables accurate, context-aware search results, improving knowledge discovery and information retrieval for various applications including research, e-commerce, and content management systems.";
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '-50px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      // Show coaching card immediately when section becomes visible
      setShowCoachingCard(true);

      // Start typewriter effect only when user navigates to this section
      let currentIndex = 0;
      const typeInterval = setInterval(() => {
        if (currentIndex <= fullText.length) {
          setTypedText(fullText.slice(0, currentIndex));
          currentIndex++;
        } else {
          clearInterval(typeInterval);
        }
      }, 50);

      return () => clearInterval(typeInterval);
    }
  }, [isVisible, fullText]);

  return (
    <section className="semantic-search-section" ref={sectionRef}>
      <div className="semantic-search-container">
        <div className={`semantic-search-header ${isVisible ? 'animate-up' : ''}`}>
          <p className="semantic-search-subtitle">Hybrid Semantic Retrieval System</p>
          <h2 className="semantic-search-title">Leverages LLMs, vector databases, and MeSH enrichment to enhance the accuracy and depth of PubMed information search.</h2>
        </div>
        <div className="semantic-search-content">
          <div className="semantic-search-left-section">
            <div className={`semantic-search-logo-section ${isVisible ? 'slide-in-left' : ''}`}>
              <div className="semantic-search-logo-large">
                <svg width="90" height="90" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="11" cy="11" r="8" stroke="#3b82f6" strokeWidth="2" />
                  <line x1="16.5" y1="16.5" x2="22" y2="22" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" />
                  <circle cx="11" cy="11" r="5" fill="#3b82f6" opacity="0.2" />
                  <circle cx="9" cy="10" r="1" fill="#3b82f6" />
                  <circle cx="13" cy="12" r="0.8" fill="#3b82f6" />
                </svg>
              </div>
              <div className="semantic-search-project-info">
                <h3>Semantic Search Initiative</h3>
                <p>Intelligent Information Retrieval</p>
              </div>
            </div>
          </div>

          <div className="semantic-search-center-section">
            <div className={`expanding-container ${typedText ? 'expanded' : ''}`}>
              <p className="typewriter-text">{typedText}</p>
              <span className="cursor">|</span>
            </div>

            <div className={`semantic-search-card ${showCoachingCard ? 'slide-up' : ''}`}>
              {/* Image Slideshow Container - positioned above the feature points */}
              <div className="image-slideshow-container">
                <div className="slideshow-wrapper">
                  <div className={`slide ${currentSlide === 0 ? 'active' : ''}`}>
                    <img src={semantic1} alt="Semantic Search 1" className="slide-image" />
                  </div>
                  <div className={`slide ${currentSlide === 1 ? 'active' : ''}`}>
                    <img src={semantic2} alt="Semantic Search 2" className="slide-image" />
                  </div>
                  <div className={`slide ${currentSlide === 2 ? 'active' : ''}`}>
                    <img src={semantic3} alt="Semantic Search 3" className="slide-image" />
                  </div>
                  <div className={`slide ${currentSlide === 3 ? 'active' : ''}`}>
                    <img src={semantic4} alt="Semantic Search 4" className="slide-image" />
                  </div>
                  <div className={`slide ${currentSlide === 4 ? 'active' : ''}`}>
                    <img src={semantic5} alt="Semantic Search 5" className="slide-image" />
                  </div>
                </div>
                <div className="slide-dots">
                  <button className={`dot ${currentSlide === 0 ? 'active' : ''}`} onClick={() => setCurrentSlide(0)}></button>
                  <button className={`dot ${currentSlide === 1 ? 'active' : ''}`} onClick={() => setCurrentSlide(1)}></button>
                  <button className={`dot ${currentSlide === 2 ? 'active' : ''}`} onClick={() => setCurrentSlide(2)}></button>
                  <button className={`dot ${currentSlide === 3 ? 'active' : ''}`} onClick={() => setCurrentSlide(3)}></button>
                  <button className={`dot ${currentSlide === 4 ? 'active' : ''}`} onClick={() => setCurrentSlide(4)}></button>
                </div>
              </div>

              <div className="semantic-search-features-combined">
                <div className="feature-item">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#2563eb" />
                  </svg>
                  <span>LLM-powered Query Expansion for smarter biomedical term mapping</span>
                </div>
                <div className="feature-item">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#2563eb" />
                  </svg>
                  <span>Hybrid Retrieval (Semantic + BM25) for balanced precision and recall</span>
                </div>
                <div className="feature-item">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#2563eb" />
                  </svg>
                  <span>MedCPT Embeddings capturing deep biomedical context</span>
                </div>
                <div className="feature-item">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#2563eb" />
                  </svg>
                  <span>Explainable Ranking for transparent and meaningful literature results</span>
                </div>
              </div>
            </div>

            <div className="github-btn-container">
              <a
                href="https://github.com/Mujakathali/pubmed"
                target="_blank"
                rel="noopener noreferrer"
                className="github-btn"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                </svg>
                View on GitHub
              </a>
            </div>
          </div>

          <div className="semantic-search-right-section">
            {/* Add any right section content here if needed */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SemanticSearchEngine;
